import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, Card, Image } from 'react-bootstrap';
import paths from 'routes/paths';
import Avatar from 'components/common/Avatar';
import { toast } from 'react-toastify';
import Flex from 'components/common/Flex';

const UserJobCard = ({
  element,
  jobFinalSelectionNurseId,
  setJobFinalSelectionNurseId
}) => {
  const { id, totalHours } = element;

  return (
    <Card
      className="p-1 px-2 m-2"
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        alignContent: 'center',
        backgroundColor:
          jobFinalSelectionNurseId === id?.uniqueId
            ? '#e6ffe6'
            : id?.availableTime
            ? '#fff'
            : '#ffcccc',
        cursor: 'pointer'
      }}
      onClick={() =>
        id?.availableTime
          ? jobFinalSelectionNurseId === id?.uniqueId
            ? setJobFinalSelectionNurseId('')
            : setJobFinalSelectionNurseId(id?.uniqueId)
          : toast.warn('Nurse is not available', {
              theme: 'colored'
            })
      }
    >
      <Link to={paths.nursd_profile(id, 'profile')}>
        {id?.profile ? (
          <Image
            thumbnail
            fluid
            roundedCircle
            className="mb-3 shadow-sm"
            src={id?.profile}
            width={50}
            height={50}
          />
        ) : (
          <Avatar size="2xl" name={id?.name} className="me-2" />
        )}
      </Link>
      <div className="pt-3">
        <h6 className="mb-1 text-primary">{id?.name}</h6>
        <Flex>
          <p className="text-700 fs-11">{id?.license}-</p>
          <p className="text-700 text-success fs-11">{totalHours}h</p>
        </Flex>
      </div>
      {id?.nurseAppAccessControl && (
        <Button
          size="sm"
          variant={id?.nurseAppAccessControl ? 'danger' : 'success'}
          className="mx-3"
        >
          {id?.nurseAppAccessControl ? 'Unsuspend' : ''}
        </Button>
      )}
    </Card>
  );
};

UserJobCard.propTypes = {
  element: PropTypes.any,
  jobFinalSelectionNurseId: PropTypes.any,
  setJobFinalSelectionNurseId: PropTypes.any,
  buttonType: PropTypes.any
};

export default UserJobCard;
